export enum SubscriptionRequestTypeEnum {
  AddNewSubscription = 'Add new subscription',
  CancelExistingSubscription = 'Cancel existing subscription',
  UpdateExistingSubscription = 'Update existing subscription',
}
